<div a-style w="100%" br="1px solid #e4e4e4" brRadius="0.6"  p="1.6">
    <!-- <p a-style fs="1.6" color="#333333" fw="600" align="center"> {{description}}  </p> -->
    <img a-style [src]="image" h="30" w="100%" >
    <ng-content></ng-content>
</div>